import bcrypt from 'bcryptjs';
import { useState } from 'react';
import UserProfileForm from '../../components/admin/profile/UserProfileForm';
import * as Constants from '../../constants';

function ProfilePage(props) {
    const [responseMsg, setResponseMsg] = useState("");
    // const [createConfirmationIsShown, setCreateConfirmationIsShown] = useState(false);
    const [msgVariant, setMsgVariant] = useState("warning");
    const [responseHeader, setResponseHeader] = useState("");


    const updateProfile = async (data) => {
        data['password'] = bcrypt.hashSync(data['password'], 12);
        data['confirmPassword'] = bcrypt.hashSync(data['password'], 12);
        const url = Constants.PROFILE_UPDATE;

        const controller = new AbortController();
        const signal = controller.signal;
        
        const token = localStorage.getItem("token");

        await fetch(url, {
            method: 'PUT',
            signal: signal,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); // Converte a resposta em JSON
            })
            .then(data => {
                if (data.status === 200) {
                    setMsgVariant("success");
                    setResponseHeader("Sucesso!");
                } else {
                    setMsgVariant("warning");
                    setResponseHeader("Atenção!");
                }
                setResponseMsg(data.message);
                // setCreateConfirmationIsShown(true);
            })
            .catch(error => {
                console.error('Erro na requisição:', error);
            });
    };

    return <>
        <UserProfileForm create={false} submitHandler={updateProfile} editPassword={false} />
    </>
}

export default ProfilePage;